(function () {

  'use strict';


  /* ========================================================
     POP CAMPAIGN
     COUNTDOWN
  ======================================================== */


  function padNumber(number) {

    return number < 10
      ? '0' + number
      : String(number);

  }



  /* ========================================================
     INITIALIZE ONE SECTION
  ======================================================== */

  function initCampaign(section) {

    if (!section) {
      return;
    }


    /*
    ----------------------------------------------------------
    DATES

    Liquid側から
    ISO 8601形式で取得
    ----------------------------------------------------------
    */

    var startString =
      section.getAttribute(
        'data-campaign-start'
      );


    var endString =
      section.getAttribute(
        'data-campaign-end'
      );


    var startTime =
      new Date(startString).getTime();


    var endTime =
      new Date(endString).getTime();



    /*
    ----------------------------------------------------------
    INVALID DATE CHECK
    ----------------------------------------------------------
    */

    if (
      isNaN(startTime) ||
      isNaN(endTime)
    ) {

      return;

    }



    /*
    ----------------------------------------------------------
    ELEMENTS
    ----------------------------------------------------------
    */

    var dayElement =
      section.querySelector(
        '[data-pop-days]'
      );


    var hourElement =
      section.querySelector(
        '[data-pop-hours]'
      );


    var minuteElement =
      section.querySelector(
        '[data-pop-minutes]'
      );


    var secondElement =
      section.querySelector(
        '[data-pop-seconds]'
      );


    var countdownLabel =
      section.querySelector(
        '[data-pop-countdown-label]'
      );


    var status =
      section.querySelector(
        '[data-pop-status]'
      );


    var statusText =
      section.querySelector(
        '[data-pop-status-text]'
      );



    /*
    ----------------------------------------------------------
    REQUIRED ELEMENT CHECK
    ----------------------------------------------------------
    */

    if (
      !dayElement ||
      !hourElement ||
      !minuteElement ||
      !secondElement ||
      !countdownLabel
    ) {

      return;

    }



    /*
    ----------------------------------------------------------
    REMOVE OLD TIMER

    Shopify theme editorで
    section再読み込みされた場合にも対応
    ----------------------------------------------------------
    */

    if (
      section._popCampaignTimer
    ) {

      clearInterval(
        section._popCampaignTimer
      );


      section._popCampaignTimer =
        null;

    }



    /* ======================================================
       RENDER
    ====================================================== */

    function renderCountdown() {


      var now =
        Date.now();


      var targetTime;



      /* ====================================================
         BEFORE CAMPAIGN
      ==================================================== */

      if (
        now < startTime
      ) {


        targetTime =
          startTime;


        countdownLabel.textContent =
          'CAMPAIGN STARTS IN';



        if (
          statusText
        ) {

          statusText.textContent =
            'UPCOMING';

        }



        if (
          status
        ) {

          status.classList.remove(
            'is-live'
          );


          status.classList.remove(
            'is-ended'
          );

        }

      }



      /* ====================================================
         LIVE
      ==================================================== */

      else if (
        now <= endTime
      ) {


        targetTime =
          endTime;


        countdownLabel.textContent =
          'CAMPAIGN ENDS IN';



        if (
          statusText
        ) {

          statusText.textContent =
            'NOW ON';

        }



        if (
          status
        ) {

          status.classList.remove(
            'is-ended'
          );


          status.classList.add(
            'is-live'
          );

        }

      }



      /* ====================================================
         ENDED
      ==================================================== */

      else {


        countdownLabel.textContent =
          'CAMPAIGN ENDED';



        if (
          statusText
        ) {

          statusText.textContent =
            'ENDED';

        }



        if (
          status
        ) {

          status.classList.remove(
            'is-live'
          );


          status.classList.add(
            'is-ended'
          );

        }



        dayElement.textContent =
          '00';


        hourElement.textContent =
          '00';


        minuteElement.textContent =
          '00';


        secondElement.textContent =
          '00';



        if (
          section._popCampaignTimer
        ) {

          clearInterval(
            section._popCampaignTimer
          );


          section._popCampaignTimer =
            null;

        }


        return;

      }



      /* ====================================================
         DIFFERENCE
      ==================================================== */

      var difference =
        Math.max(
          0,
          targetTime - now
        );



      var days =
        Math.floor(
          difference /
          86400000
        );



      var hours =
        Math.floor(
          (
            difference %
            86400000
          ) /
          3600000
        );



      var minutes =
        Math.floor(
          (
            difference %
            3600000
          ) /
          60000
        );



      var seconds =
        Math.floor(
          (
            difference %
            60000
          ) /
          1000
        );



      /* ====================================================
         OUTPUT
      ==================================================== */

      dayElement.textContent =
        padNumber(days);


      hourElement.textContent =
        padNumber(hours);


      minuteElement.textContent =
        padNumber(minutes);


      secondElement.textContent =
        padNumber(seconds);

    }



    /* ======================================================
       FIRST RENDER
    ====================================================== */

    renderCountdown();



    /* ======================================================
       TIMER
    ====================================================== */

    section._popCampaignTimer =
      window.setInterval(
        renderCountdown,
        1000
      );

  }



  /* ========================================================
     INITIALIZE ALL
  ======================================================== */

  function initAllCampaigns(root) {


    var searchRoot =
      root || document;


    /*
    section自身が対象の場合
    */

    if (
      searchRoot.matches &&
      searchRoot.matches(
        '[data-pop-campaign]'
      )
    ) {

      initCampaign(
        searchRoot
      );

    }



    /*
    section内部を検索
    */

    var campaigns =
      searchRoot.querySelectorAll
        ? searchRoot.querySelectorAll(
            '[data-pop-campaign]'
          )
        : [];


    campaigns.forEach(
      function (campaign) {

        initCampaign(
          campaign
        );

      }
    );

  }



  /* ========================================================
     NORMAL PAGE LOAD
  ======================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAllCampaigns(
          document
        );

      },
      {
        once: true
      }
    );

  }

  else {

    initAllCampaigns(
      document
    );

  }



  /* ========================================================
     SHOPIFY THEME EDITOR
  ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllCampaigns(
        event.target
      );

    }
  );



  /* ========================================================
     SECTION UNLOAD

     theme editor上で削除された時
     timerを止める
  ======================================================== */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {


      var section =
        event.target.querySelector(
          '[data-pop-campaign]'
        );


      if (
        section &&
        section._popCampaignTimer
      ) {

        clearInterval(
          section._popCampaignTimer
        );


        section._popCampaignTimer =
          null;

      }

    }
  );


})();